import { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import { isMoneyInput } from "./transfer.utils";

/** A money grid reads as columns of figures, so an empty cell shows a 0 rather than words. */
const DEFAULT_PLACEHOLDER = "0";

interface AmountInputProps {
  label: string;
  value: string;
  error?: string;
  disabled?: boolean;
  /** Overrides the 0 where an empty field must not be mistaken for a keyed zero. */
  placeholder?: string;
  onChange: (value: string) => void;
}

/**
 * One money field on a sale-deposit form.
 *
 * Rejects a keystroke that would make the value un-saveable rather than accepting it and
 * complaining afterwards, so the only errors the caller has to report are the ones a valid
 * keystroke sequence can still produce (an empty รายการ, say).
 */
export default function AmountInput({
  label,
  value,
  error,
  disabled,
  placeholder = DEFAULT_PLACEHOLDER,
  onChange,
}: AmountInputProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const next = event.target.value;
    if (isMoneyInput(next)) onChange(next);
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleChange}
      type="text"
      placeholder={placeholder}
      size="small"
      fullWidth
      disabled={disabled}
      error={Boolean(error)}
      helperText={error}
      slotProps={{
        htmlInput: { inputMode: "decimal" },
        // Keep the label floated so the placeholder shows without overlap.
        inputLabel: { shrink: true },
      }}
    />
  );
}
